import { render, staticRenderFns } from "./StudioListOld.vue?vue&type=template&id=6e3fde28&scoped=true"
import script from "./StudioListOld.vue?vue&type=script&lang=js"
export * from "./StudioListOld.vue?vue&type=script&lang=js"
import style0 from "./StudioListOld.vue?vue&type=style&index=0&id=6e3fde28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3fde28",
  null
  
)

export default component.exports